import { FC } from "react";

interface LoaderPanelProps {
  className?: string;
}

const LoaderPanel: FC<LoaderPanelProps> = ({ className }) => (
  <div className={`loader ${className}`} style={{ backgroundImage: `url(/magrabi/images/preloader.gif)` }} />
);

export default LoaderPanel;
